import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher, UrlSegment } from '@angular/router';

const standaloneMatcher: UrlMatcher = (url: UrlSegment[]) =>
    url[url.length - 1].path.endsWith('filesAndLinks')
        ? { consumed: url, posParams: { mmsId: url[url.length - 2] } }
        : null;

const routes: Routes = [
    {
        matcher: standaloneMatcher,
        loadComponent: () =>
            import(
                './asset-page-arcview-standalone/asset-page-arcview-standalone.component'
            ).then((m) => m.AssetPageArcviewStandaloneComponent),
    },

    {
        path: '**',
        loadComponent: () =>
            import('./asset-page.component').then((m) => m.AssetPageComponent),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AssetPageRoutingModule {}
